module.exports = __webpack_public_path__ + "static/media/access.d89abaff.svg";